<template>
  <v-card>
    <alert-error :error="error"></alert-error>
    <v-card-text>
      <persons-option-form v-model="personOptions" :options="options || []">
        <template v-if="showButtons" v-slot:buttons="{ valid }">
          <v-btn
            outlined
            class="mr-5"
            depressed
            color="grey"
            large
            @click="cancel"
          >
            {{ $t('BUTTON.CANCEL') }}
          </v-btn>
          <v-btn
            depressed
            type="submit"
            :disabled="!valid"
            large
            color="success"
            class="mr-5"
            @click.prevent="update"
          >
            {{ $t('BUTTON.UPDATE') }}
          </v-btn>
        </template>
      </persons-option-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  name: 'PersonsCommunicationOptionsPage',

  components: {
    AlertError: () => import('@/modules/_global/_components/AlertError'),
    PersonsOptionForm: () => import('@/modules/communication_options/components/PersonsCommunicationOptionsForm.vue')
  },

  props: {
    personId: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    unwatch: null,
    locale: '',
    copyPersonTags: [],
    personOptions: [],
    options: [],
    error: null,
    valid: true,
    showButtons: false
  }),

  computed: {
    loading() {
      return this.$store.getters['loading'];
    }
  },

  watch: {
    personOptions: {
      deep: true,
      handler: 'checkPersonTags'
    }
  },

  created() {
    this.unwatch = this.$store.watch(
      state => state.localization.lang,
      () => {
        const lang = this.$store.state.localization.lang;

        if (lang) {
          this.getTags();
        }
      }
    );
    this.getPersonTags();
    this.getTags();
  },

  destroyed() {
    this.unwatch();
  },

  methods: {
    getTags() {
      this.$store
        .dispatch('communication_options/index')
        .then(({ data }) => {
          this.options = data.data;
        })
        .catch(error => {
          this.error = error.response;
        });
    },
    getPersonTags() {
      this.$store
        .dispatch('communication_options/person', this.personId)
        .then(({ data }) => {
          this.personOptions = data;
          this.copyPersonTags = cloneDeep(this.personOptions);
        })
        .catch(error => {
          this.error = error.response;
        });
    },
    update() {
      this.$store
        .dispatch('communication_options/assign', {
          person_id: this.personId,
          personOptions: this.personOptions
        })
        .then(({ data }) => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$emit('success', data);
          this.copyPersonTags = cloneDeep(this.personOptions);
          this.showButtons = false;
        })
        .catch(error => {
          this.error = error.response;
        });
    },
    cancel() {
      this.personOptions = cloneDeep(this.copyPersonTags);
      this.error = null;
    },
    checkPersonTags(val) {
      this.showButtons =
        JSON.stringify(this.copyPersonTags) !== JSON.stringify(val);
    }
  }
};
</script>
